export type FilterState = {
  type: string;
  region: string;
  year: string;
  status: string;
};

const options = {
  type: ["全部", "科幻", "奇幻", "治愈", "机甲", "武侠", "悬疑", "日常", "冒险", "音乐"],
  region: ["全部", "国漫", "日漫", "韩漫"],
  year: ["全部", "2026", "2025", "2024"],
  status: ["全部", "连载中", "已完结"],
};

const labels: Record<keyof FilterState, string> = {
  type: "类型",
  region: "地区",
  year: "年份",
  status: "状态",
};

type FilterBarProps = {
  value: FilterState;
  onChange: (next: FilterState) => void;
  onReset: () => void;
  resultCount: number;
};

export default function FilterBar({ value, onChange, onReset, resultCount }: FilterBarProps) {
  const activeCount = Object.values(value).filter((v) => v !== "全部").length;

  return (
    <div className="w-full rounded-lg bg-background-100 border border-background-200 p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span className="w-6 h-6 rounded-md bg-primary-900 text-background-50 flex items-center justify-center">
            <i className="ri-filter-3-line text-[13px]" />
          </span>
          <h2 className="text-[14px] font-semibold text-foreground-950">
            多维筛选
            {activeCount > 0 && (
              <span className="ml-1.5 text-[12px] font-medium text-accent-700">已选 {activeCount} 项</span>
            )}
          </h2>
        </div>
        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center gap-1 text-[12px] text-foreground-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line" /> 重置筛选
        </button>
      </div>

      <div className="space-y-3">
        {(Object.keys(options) as (keyof FilterState)[]).map((key) => (
          <div key={key} className="flex flex-col sm:flex-row sm:items-start gap-2">
            <span className="text-[12px] text-foreground-500 sm:w-12 shrink-0 sm:pt-1.5">{labels[key]}</span>
            <div className="flex flex-wrap gap-1.5">
              {options[key].map((opt) => (
                <button
                  key={opt}
                  type="button"
                  onClick={() => onChange({ ...value, [key]: opt })}
                  className={`px-3 py-1.5 rounded-full text-[12px] font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    value[key] === opt
                      ? "bg-primary-900 text-background-50"
                      : "bg-background-50 text-foreground-700 border border-background-200 hover:border-primary-300 hover:text-primary-700"
                  }`}
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 pt-3 border-t border-background-200 text-[12px] text-foreground-600">
        共匹配到 <span className="font-bold text-primary-800">{resultCount}</span> 部作品
      </div>
    </div>
  );
}